module.exports = __webpack_public_path__ + "img/info_ico_blue.ff44c910.svg";